import { Grid, Button, Container, Link, Typography, Theme, Box } from '@mui/material';
import { Rating, ProfileAvatar } from '@care/react-component-lib';
import useMediaQuery from '@mui/material/useMediaQuery';
import dateMonthYearFormat from '@/utils/dateMonthYearFormat';
import { getUserInitials } from '@/utils/getUserInitials';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';

interface CaregiverReview {
  reviewDate: string | Date;
  rating: number;
  comment: string;
  reviewer: Reviewer;
}

interface Reviewer {
  displayName: string;
  imageURL: string;
}

const RecentReview = ({
  latestReview,
  numOfReviews,
  joinNowURL,
}: {
  latestReview: CaregiverReview;
  numOfReviews: Number;
  joinNowURL: string;
}) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const handleReadAllReviews = () => {
    const amplitudeData = {
      cta_text: 'Read all reviews',
      cta_type: 'button',
    };

    trackAmplitudeEvent(AmplitudeEvent.ctaInteracted, amplitudeData);
  };

  return (
    <Container maxWidth="md" sx={{ pt: 1 }}>
      <Typography variant={isMobileOrSmaller ? 'h2' : 'h1'} component="h2" mb={3}>
        Most recent review
      </Typography>
      <Grid container width="330px">
        <Grid item xs={2}>
          <ProfileAvatar size="large" src={latestReview.reviewer.imageURL}>
            {getUserInitials(latestReview.reviewer.displayName)}
          </ProfileAvatar>
        </Grid>
        <Grid item xs={10} pl={2}>
          <Typography variant={isMobileOrSmaller ? 'h5' : 'h4'} mb={1}>
            {latestReview.reviewer.displayName}
          </Typography>
          <Rating name="size-large" defaultValue={latestReview.rating} readOnly />
          <Typography variant={isMobileOrSmaller ? 'info1' : 'body3'}>
            {dateMonthYearFormat({
              dateTime: latestReview.reviewDate,
              useOrdinalDay: true,
              useFullDate: true,
            })}{' '}
          </Typography>
        </Grid>
      </Grid>
      <Box my={2} mx={0}>
        <Typography variant="body2">{latestReview.comment}</Typography>
      </Box>
      <Typography variant="info1" color="care.grey.700">
        Showing results 1 of {numOfReviews}
      </Typography>
      <Box textAlign="center" mt={3} mb={1}>
        <Link href={joinNowURL} rel="nofollow">
          <Button
            className="flexible"
            color="secondary"
            onClick={handleReadAllReviews}
            variant="outlined">
            Read all reviews
          </Button>
        </Link>
      </Box>
    </Container>
  );
};

export default RecentReview;
